const IMAGE_DPI = 37;
// let dragStartX,dragStartY,dragOffsetX = 0,dragOffsetY = 0;
let finalImagePreview; // Variable to store the final image preview
let appState = []; // Global state to hold all input configurations
let klassikMattPriceGroup = klassikMattPricesGroupObj;
let deluxGlassopticPriceGroup = deluxeGlasoptikPricesGroupObj;
let cropperInstance = null;
let savedCropData = {};
let imageAreaPopupImage = document.querySelector('.config-main-product #popup-image');
// let draggableArea = document.querySelector('.config-main-product #draggable-area');
let imageAreapopup = document.querySelector('.config-main-product #resizeModalWindow');
let configBackBtn = document.querySelectorAll('.config-main-product [data-back-button]');
let defaultCropMap = {};
// defaultCropMap[index] = null;

// Holds the live state of the multi-crop overlay while the modal is open.
let activeCropContext = null;

// The tile row's top-left offset in NATURAL image pixels (user-draggable).
// null = auto-center the row. This is the single source of truth for where
// the whole tiled composition sits on the image.
let cropGroup = null;


const priceFormat = new Intl.NumberFormat("de-DE", {
  style: "currency",
  currency: `${Shopify.currency.active}`
});


document.addEventListener('DOMContentLoaded', () => {

  // Build marker — check the browser console to confirm THIS file is live.
  console.log('[configurator] build: tallest-piece=full-height + looping + fit-to-container (2026-07-17)');

  const configContainers = document.querySelectorAll(".desktop-layout-wrapper, .mobile-layout-wrapper");
  initContainer(configContainers);
  handleAdditionalProdRadio();
  setMobileSliderActiveSlideHieght();

  const applyButton = document.querySelector('.config-main-product #applyButton');

  if (applyButton) {
    applyButton.addEventListener("click", () => {
      // Commit every draggable box in the overlay to its config, then redraw.
      applyMultiCropModal();
    });
  } else {
    console.warn("#applyButton not found in DOM");
  }


  if (document.querySelector('.config-main-product #cancelButton')) {
    document.querySelector('.config-main-product #cancelButton').addEventListener("click", () => {
      // Discard: just close the overlay without saving.
      closeMultiCropModal(false);
    });
  }

  if (window.matchMedia('(min-width: 991px)').matches) {
    activeStep();
    window.addEventListener('scroll', (e) => handleScrollEvent(e));
  }

  const mediaQuery = window.matchMedia("(max-width: 989px)");
  mediaQuery.addEventListener("change", function () {
    location.reload();
  });

  // Keep the preview row fitted to its container as the viewport changes.
  let _fitRaf = null;
  window.addEventListener('resize', () => {
    if (_fitRaf) cancelAnimationFrame(_fitRaf);
    _fitRaf = requestAnimationFrame(() => {
      document.querySelectorAll('.desktop-layout-wrapper, .mobile-layout-wrapper').forEach((c) => {
        if (c.querySelector('.cropped-image-canvas')) fitPreviewToContainer(c);
      });
    });
  });

});


function setMobileSliderActiveSlideHieght() {
  //config pdp slide height logic
  setTimeout(() => {
    if (document.querySelector('.mobile-layout-wrapper .step-slide.active-slide')) {
      let currentHeight = document.querySelector('.mobile-layout-wrapper .step-slide.active-slide').offsetHeight;
      if (document.querySelector('.mobile-layout-wrapper .configure-mobile-slider')) {
        window.requestAnimationFrame(() => {
          document.querySelector('.mobile-layout-wrapper .configure-mobile-slider').style.height = `${currentHeight}px`;
        });
      }
    }

    //update swiper instaces for re-calculate slider height
    document.querySelector(`[data-mobile-config-slider]`)?.swiper?.update();
  }, 200);
}

function isCropChanged(current, original) {
  if (!current || !original) return false;

  const tolerance = 2;

  return (
    Math.abs(current.x - original.x) > tolerance ||
    Math.abs(current.y - original.y) > tolerance ||
    Math.abs(current.width - original.width) > tolerance ||
    Math.abs(current.height - original.height) > tolerance
  );
}

function showResetPopup(onConfirm) {
  const popup = document.getElementById('reset-warning-popup');
  const confirmBtn = document.getElementById('confirmReset');
  const cancelBtn = document.getElementById('cancelReset');

  popup.classList.remove('hidden');

  const handleConfirm = () => {
    popup.classList.add('hidden');
    cleanup();
    onConfirm();
  };

  const handleCancel = () => {
    popup.classList.add('hidden');
    cleanup();
  };

  function cleanup() {
    confirmBtn.removeEventListener('click', handleConfirm);
    cancelBtn.removeEventListener('click', handleCancel);
  }

  confirmBtn.addEventListener('click', handleConfirm);
  cancelBtn.addEventListener('click', handleCancel);
}

function showAutoPopup(message, onClose, showActions = false) {
  const popup = document.getElementById('reset-warning-popup');
  const messageBox = popup.querySelector('p');

  messageBox.innerHTML = message;

  popup.classList.remove('hidden');

  const actions = popup.querySelector('.reset-warning-actions');
  if (actions) actions.style.display = showActions ? 'flex' : 'none';
}

const popup = document.getElementById('reset-warning-popup');
const overlay = popup?.querySelector('.reset-warning-overlay');

const closePopupBtn = document.querySelector('.close-waring-popup-btn');
if (overlay) {
  overlay.addEventListener('click', () => {
    popup.classList.add('hidden');
  });
}
if (closePopupBtn) {
  closePopupBtn.addEventListener('click', () => {
    popup.classList.add('hidden');
  });
}

function toggleChangeAreaButton(container) {
  const changeAreaBtn = container.querySelector('.change-area-btn');
  if (!changeAreaBtn) return;

  // ✅ Change-area is now allowed for every panel (multi-config supported),
  //    so the button stays enabled regardless of how many panels exist.
  changeAreaBtn.classList.remove('disabled');
}

function initContainer(configContainers) {
  if (configContainers.length) {
    configContainers.forEach(container => {
      const savedState = sessionStorage.getItem('appState');
      if (savedState) {
        appState = JSON.parse(savedState);
      } else {
        appState = [{ height: 40, width: 50 }]; // Initialize state with a single default input
      }

      // Restore any manual crops saved in a previous session BEFORE the
      // canvases render, so cropped configs keep their crop and uncropped
      // ones fall back to a centered crop.
      loadCropState();

      loadInputsFromState(container);
      toggleChangeAreaButton(container);

      syncHiddenProperties();


      let changeAreaButton = container.querySelector(`.change-area-btn`);
      if (changeAreaButton) {
        changeAreaButton.addEventListener("click", () => {
          // Opens a modal with ONE draggable box PER config, each sized
          // proportionally to that config's cm vs the max size.
          openMultiCropModal(container);
        });
      }

      // Add more configure input box
      const addMoreConfigProBtn = container.querySelectorAll('#addMoreConfigPro');
      if (addMoreConfigProBtn.length) {
        addMoreConfigProBtn.forEach(btn => {
          btn.addEventListener('click', (e) => {

            e.preventDefault();

            // ✅ Panels are now fully independent — adding a new panel no longer
            //    resets any existing panel's crop, so we simply push a new one.
            if (appState.length < 5) {
              // Don't let a new (50 cm default) panel push past the max motive length.
              const maxTotal = getMaxTotalWidthCm(container);
              if (getTotalWidthCm() + 50 > maxTotal) {
                const errEl = getTotalWidthErrorEl(container);
                if (errEl) {
                  const meters = (maxTotal / 100).toLocaleString('de-DE');
                  errEl.textContent = `Die Gesamtbreite aller Teile darf höchstens ${maxTotal} cm (${meters} m) betragen.`;
                  errEl.classList.add('error-active');
                  errEl.style.display = '';
                }
                return;
              }
              appState.push({ height: 40, width: 50 });
              saveState();
              loadInputsFromState(container);
              toggleChangeAreaButton(container);
              setMobileSliderActiveSlideHieght();
              handleDataLayer(appState.length - 1, 'update');
              syncHiddenProperties();
            }

          });
        });

        container.addEventListener('click', (event) => {

          if (event.target.closest('.remove-button')) {
            // Event delegation for the "Remove Configure Input Box" buttons
            const elementToRemove = event.target.closest('[data-dimensions-input]');
            if (elementToRemove) {
              const wrapper = elementToRemove.closest(`.config-dimensions-input-wrapper`);
              const index = Array.from(wrapper.querySelectorAll('[data-dimensions-input]')).indexOf(elementToRemove);
              if (index !== -1) {
                appState.splice(index, 1);
                saveState();

                // ✅ Re-key BOTH crop maps so crops/defaults stay aligned with
                //    their panels after a removal (no leaking into other indexes).
                const oldCrop = savedCropData;
                const oldDefault = defaultCropMap;
                const newCrop = {};
                const newDefault = {};
                let write = 0;
                Object.keys(oldCrop)
                  .map(Number)
                  .sort((a, b) => a - b)
                  .forEach((oldIndex) => {
                    if (oldIndex === index) return; // dropped panel
                    const target = oldIndex > index ? oldIndex - 1 : oldIndex;
                    newCrop[target] = oldCrop[oldIndex] || null;
                    newDefault[target] = oldDefault[oldIndex] || null;
                    write = target;
                  });
                savedCropData = newCrop;
                defaultCropMap = newDefault;
                saveCropState();

                loadInputsFromState(container);
                toggleChangeAreaButton(container);
                setMobileSliderActiveSlideHieght();

                syncHiddenProperties();
                // Update DataLayer
                handleDataLayer(index, 'remove');
              }
            }
          } else {
            // Set active input box with relevant canvas
            if (event.target.closest('[data-dimensions-input]')) {
              const closestEle = event.target.closest('[data-dimensions-input]');
              if (!closestEle.classList.contains(`active-input`)) {
                const allInputEle = container.querySelectorAll(`[data-dimensions-input]`);
                if (allInputEle.length) {
                  allInputEle.forEach(ele => ele.classList.remove(`active-input`));
                  closestEle.classList.add(`active-input`);
                  setCanvasActiveClass(container);
                }
              }
            }
          }
          const canvasWrapper = event.target.closest('.cropped-image-wrap');
          if (canvasWrapper && container.contains(canvasWrapper)) {

            const index = canvasWrapper.dataset.canvasIndex;
            if (index === undefined) return;

            // Remove active-input from all inputs
            const allInputs = container.querySelectorAll('[data-dimensions-input]');
            allInputs.forEach(ele => ele.classList.remove('active-input'));

            // Activate matching input
            const matchingInput = container.querySelector(
              `[data-dimensions-input][data-index="${index}"]`
            );

            if (matchingInput) {
              matchingInput.classList.add('active-input');
              setCanvasActiveClass(container);
              updatePrintProperties(index);
            }

            return; // prevent falling into other click logic
          }
        });
      }
    });
  }
}

function getActiveIndex() {
  const active = document.querySelector(
    '.desktop-layout-wrapper [data-dimensions-input].active-input, \
     .mobile-layout-wrapper [data-dimensions-input].active-input'
  );
  return active ? Number(active.dataset.index) : 0;
}

document.addEventListener('input', (event) => {
  const input = event.target;

  if (!input.classList.contains('crop-width') && !input.classList.contains('crop-height')) return;

  const inputBox = input.closest('[data-dimensions-input]');
  if (!inputBox) return;

  var index = Number(inputBox.dataset.index ?? 0);

  const container = input.closest('.desktop-layout-wrapper, .mobile-layout-wrapper');

  const isPopup = !container;

  let targetContainer;

  if (isPopup) {
    index = getActiveIndex();
    // fallback to active container
    targetContainer = document.querySelector('.desktop-layout-wrapper, .mobile-layout-wrapper');
  } else {
    targetContainer = container;
  }

  if (!targetContainer) return;

  // ✅ Changing THIS panel's size changes its aspect ratio, so its old manual
  //    crop no longer fits. Invalidate ONLY this index (drop the manual flag).
  //    Every other panel keeps its crop untouched.
  if (savedCropData[index]) savedCropData[index].manual = false;

  if (input.classList.contains('crop-width')) {
    // Cap this width so the SUM of all pieces never exceeds the 5 m limit.
    // If it would overflow, the field is replaced by the remaining allowance
    // and an error is shown on THIS input.
    const info = clampWidthToTotal(input, index, targetContainer);
    handleInputChange(input.value, 'width', index, targetContainer);
    if (info.clamped) {
      showInputWidthError(targetContainer, index, info.maxTotal, info.remaining);
    }
  }

  if (input.classList.contains('crop-height')) {
    handleInputChange(input.value, 'height', index, targetContainer);
  }

  syncPopupWithMain(index);
});

function syncPopupWithMain(index) {
  const popup = document.querySelector('#resizeModalWindow');
  if (!popup || popup.classList.contains('hidden')) return;

  const state = appState[index];
  if (!state) return;

  const popupHeight = popup.querySelector('.crop-height');
  const popupWidth = popup.querySelector('.crop-width');

  if (popupHeight && document.activeElement !== popupHeight) {
    popupHeight.value = state.height;
  }

  if (popupWidth && document.activeElement !== popupWidth) {
    popupWidth.value = state.width;
  }
}

function loadInputsFromState(container) {
  const wrapper = container.querySelectorAll(`.config-dimensions-input-wrapper`);
  if (!wrapper.length) return;

  wrapper.forEach(wrapper => {
    // Clear existing inputs

    const maxHeight = parseFloat(
      wrapper.querySelector('[data-max-height]').dataset.maxHeight
    );

    const maxWidth = parseFloat(
      wrapper.querySelector('[data-max-width]').dataset.maxWidth
    );

    wrapper.querySelectorAll('[data-dimensions-input]').forEach(el => el.remove());

    // Create new inputs based on the state
    appState.forEach((config, index) => {
      const newElement = document.createElement('div');
      newElement.classList.add('controls', 'config-dimensions-input');
      if (appState.length - 1 === index) newElement.classList.add('active-input');
      newElement.setAttribute('data-dimensions-input', '');
      newElement.setAttribute('data-index', index);
      newElement.innerHTML = `
        ${appState.length > 1 ? `<div class="remove-button-wrapper"><span class="config-index">${index + 1}</span><button class="remove-button"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-minus-icon"><path d="M5 12h14"></path></svg></button></div>` : ``}
        <div id="error-message-${index}" class="error-message"></div>
        <div class="config-dimensions-row">
            <div class="config-dimensions-box" data-max-height="${maxHeight}">
                <label>Höhe 40 - ${maxHeight}</label>
                <div class="input-wrap">
                    <input type="number" class="crop-height" placeholder="Höhe" min="40" max="${maxHeight}" value="${config.height}">
                    <span>cm</span>
                </div>
            </div>
            <div class="config-dimensions-box" data-max-width="${maxWidth}">
                <label>Breite 50 - ${maxWidth}</label>
                <div class="input-wrap">
                    <input type="number" class="crop-width" placeholder="Breite" min="50" max="${maxWidth}" value="${config.width}">
                    <span>cm</span>
                </div>
            </div>
        </div>
      `;
      const referenceNode = wrapper.querySelector(`.add-more-config-pro`);
      if (referenceNode) {
        wrapper.insertBefore(newElement, referenceNode);
      }
    });
  });

  updateAddButtonVisibility(container);
  syncInputsFromState(container);
}

function saveState() {
  sessionStorage.setItem('appState', JSON.stringify(appState));
}

// Persist the per-config crops so MANUAL crops survive a page reload.
// Configs without a manual crop simply recompute a centered crop on load.
function saveCropState() {
  try {
    sessionStorage.setItem('savedCropData', JSON.stringify(savedCropData));
    sessionStorage.setItem('cropGroup', JSON.stringify(cropGroup));
  } catch (e) { /* ignore quota / serialization errors */ }
}

function loadCropState() {
  try {
    const raw = sessionStorage.getItem('savedCropData');
    savedCropData = raw ? (JSON.parse(raw) || {}) : {};
    const g = sessionStorage.getItem('cropGroup');
    cropGroup = g ? (JSON.parse(g) || null) : null;
  } catch (e) {
    savedCropData = {};
    cropGroup = null;
  }
}

// Compute the whole tiled composition in NATURAL image pixels.
// Tiles are laid left-to-right, adjacent (tile 2 starts where tile 1 ends),
// bottom-aligned, and positioned by the shared group offset `cropGroup`
// (auto-centered when cropGroup is null). Each tile's size is proportional
// to its cm vs the max size, so 59cm of a 118cm max = half the image height.
function computeComposition(container) {
  const src = container.querySelector('.source-image');
  if (!src) return null;
  const nW = src.naturalWidth;
  const nH = src.naturalHeight;
  if (!nW || !nH) return null;

  // The TALLEST piece defines the scale: it always shows the FULL image height.
  // The same cm→pixel scale is applied to every piece's width AND height, so
  // the motive is never distorted and shorter pieces just show a cropped
  // (shorter) slice. Example: pieces 100 + 50 -> 100 fills the height, 50 is
  // half; a single 50 piece -> full height. Width may exceed one image copy,
  // which is handled by the horizontal looping below.
  // VERTICAL: the tallest piece always shows the FULL image height.
  const maxConfigH = Math.max.apply(null, appState.map((c) => Number(c.height) || 0)) || 1;
  const pxPerCmY = nH / maxConfigH;

  // HORIZONTAL: the full image width represents the max motive length (5 m),
  // so a 500 cm-wide piece selects the FULL image width — no repeated copy.
  // (Within the 5 m limit the total never exceeds one image, so it won't loop.)
  const maxTotalW = getMaxTotalWidthCm(container);
  const pxPerCmX = nW / maxTotalW;

  const sizes = appState.map((c) => ({
    nw: Number(c.width) * pxPerCmX,
    nh: Math.min(Number(c.height) * pxPerCmY, nH)
  }));

  const totalW = sizes.reduce((a, s) => a + s.nw, 0);
  const groupH = sizes.reduce((a, s) => Math.max(a, s.nh), 0);

  // The wall repeats the image horizontally (seamless tiling), so the row may
  // be WIDER than one image. Work out how many copies we need to cover it.
  const repeats = Math.max(1, Math.ceil(totalW / nW));
  const tiledW = repeats * nW; // total looped canvas width in natural px

  // group origin (top-left of the row) inside the looped space
  let gx, gy;
  if (cropGroup && typeof cropGroup.x === 'number') {
    gx = cropGroup.x;
    gy = cropGroup.y;
  } else {
    gx = (tiledW - totalW) / 2;
    gy = (nH - groupH) / 2;
  }
  // keep the row inside the looped width; height never loops
  gx = Math.max(0, Math.min(gx, tiledW - totalW));
  gy = Math.max(0, Math.min(gy, nH - groupH));

  const crops = [];
  let cum = 0;
  sizes.forEach((s, i) => {
    crops[i] = {
      x: Math.round(gx + cum),           // may exceed nW → wraps onto next copy
      y: Math.round(gy + (groupH - s.nh)), // bottom-aligned row
      width: Math.round(s.nw),
      height: Math.round(s.nh)
    };
    cum += s.nw;
  });

  return { crops, totalW, groupH, gx, gy, nW, nH, tiledW, repeats };
}

function syncInputsFromState(container) {
  const inputs = container.querySelectorAll('[data-dimensions-input]');

  const displayDimension = container.querySelector("[data-selected-dimension]");
  if (displayDimension) {
    displayDimension.innerHTML = ``;
  }

  inputs.forEach((inputContainer, index) => {
    if (!appState[index]) return;

    const heightInput = inputContainer.querySelector('.crop-height');
    const widthInput = inputContainer.querySelector('.crop-width');

    if (document.activeElement !== heightInput) {
      heightInput.value = appState[index].height ?? '';
    }

    if (document.activeElement !== widthInput) {
      widthInput.value = appState[index].width ?? '';
    }

    // Update the selected dimensions displayed
    if (displayDimension) {
      const span = document.createElement('span');
      span.setAttribute('data-index', index);
      span.textContent = `${appState[index].height}cm x ${appState[index].width}cm`;
      displayDimension.appendChild(span);
    }
  });

  //render canvas
  renderCanvases(container);

  // Recalculate prices for all inputs after syncing
  calculatePrices();

  // Enforce the max total motive length (e.g. 5 m). LAST, so it overrides the
  // per-piece Add-to-Cart enabling above when the combined width is too large.
  validateTotalWidth(container);
}

function cmToPixels(cm) {
  //return cm * (IMAGE_DPI / 2.54);
  return (cm / 2.54) * IMAGE_DPI;
}

function setCanvasActiveClass(container) {
  const selectedInputIndex = container.querySelectorAll(`.active-input[data-dimensions-input]`);
  const canvasEle = container.querySelectorAll(`.cropped-image-canvas .cropped-image-wrap`);
  if (selectedInputIndex.length) {
    if (canvasEle.length) canvasEle.forEach(el => el.classList.remove(`active`));
    if (canvasEle.length) {
      selectedInputIndex.forEach(ele => {
        const inputBoxIndex = ele.dataset.index;
        const activeCanvasEle = container.querySelectorAll(`.cropped-image-canvas [data-canvas-index="${inputBoxIndex}"]`);
        if (activeCanvasEle.length) activeCanvasEle.forEach(el => el.classList.add(`active`));
      });
    }
  }
}

function renderCanvases(container) {
  const wrapper = container.querySelector('.cropped-image-canvas');
  if (!wrapper) return;

  // Clear existing canvases
  wrapper.querySelectorAll('.cropped-image-wrap').forEach(el => el.remove());

  // Create and draw a canvas for each item in the state
  appState.forEach((config, index) => {
    const canvas = document.createElement('canvas');
    canvas.classList.add('cropped-image');

    //Canvas wrapper ele
    const canvasWrapperEle = document.createElement('div');
    canvasWrapperEle.classList.add('cropped-image-wrap');
    canvasWrapperEle.setAttribute('data-canvas-index', index);
    canvasWrapperEle.appendChild(canvas);

    wrapper.appendChild(canvasWrapperEle);

    // cropImage() reads savedCropData[index].manual, so each panel redraws
    // from its OWN crop and never disturbs the others.
    cropImage(canvas, config.width, config.height, container, index);
  });

  wrapper.removeAttribute(`class`);
  wrapper.classList.add(`product__media`, `cropped-image-canvas`, `canavs-items-${appState.length}`);

  if (appState.length > 1) {
    wrapper.classList.add(`multiple_canvas_item`);
  }

  setCanvasActiveClass(container);

  // Shrink the whole preview row to fit its container (like the reference:
  // as more equal-height panels are added, everything scales down together).
  // Display-only — does not change the crop regions or the print output.
  requestAnimationFrame(() => fitPreviewToContainer(container));
}

// Scale every preview canvas by ONE uniform factor so the whole adjacent row
// fits the available WIDTH, keeping each piece's proportions and bottom-aligning
// them. Purely visual. A SINGLE image is left entirely to the theme CSS.
function fitPreviewToContainer(container) {
  try {
    const wrapper = container.querySelector('.cropped-image-canvas');
    if (!wrapper) return;
    const wraps = Array.from(wrapper.querySelectorAll('.cropped-image-wrap'));

    // Single piece (or none): DO NOT touch it — clear any inline sizes we may
    // have added earlier so the theme's own CSS controls it (fixes the
    // "small in top-left" single-image case).
    if (wraps.length <= 1) {
      wraps.forEach((w) => {
        const cv = w.querySelector('canvas');
        if (cv) { cv.style.width = ''; cv.style.height = ''; cv.style.display = ''; }
        w.style.display = ''; w.style.verticalAlign = '';
      });
      return;
    }

    const availW = wrapper.clientWidth;
    if (!availW) return; // layout not ready yet; a later resize/redraw will fit

    let totalW = 0;
    const items = wraps.map((w) => {
      const cv = w.querySelector('canvas');
      const cw = cv ? cv.width : 0;
      const ch = cv ? cv.height : 0;
      totalW += cw;
      return { w, cv, cw, ch };
    });
    if (!totalW) return;

    // Fit by WIDTH only, and never enlarge past natural size (no height-cap, so
    // there's no dependence on the container's own height → no shrink spiral).
    const scale = Math.min(availW / totalW, 1);

    items.forEach((it) => {
      if (!it.cv) return;
      it.cv.style.width = (it.cw * scale) + 'px';
      it.cv.style.height = (it.ch * scale) + 'px';
      it.cv.style.display = 'block';
      it.w.style.display = 'inline-block';
      it.w.style.verticalAlign = 'bottom'; // bottom-align shorter pieces
    });
  } catch (e) { /* display-only; never block rendering */ }
}

function updatePrintProperties(index) {
  const printWidthInput = document.querySelector('input[name="properties[_print_width_cm]"]');
  const printHeightInput = document.querySelector('input[name="properties[_print_height_cm]"]');

  if (!printWidthInput || !printHeightInput) return;
  if (!appState[index]) return;

  printWidthInput.value = appState[index].width;
  printHeightInput.value = appState[index].height;
}


// Draw a crop region that may extend past the right edge of the image by
// wrapping onto repeated copies (seamless horizontal tiling). Vertical never
// wraps. `region.x` is in looped space; we sample with (x mod nW).
function drawTiledRegion(ctx, img, region, destW, destH, nW) {
  const scaleX = destW / region.width; // ~1 since canvas == region size
  let remaining = region.width;
  let srcX = ((region.x % nW) + nW) % nW;
  let destX = 0;
  let guard = 0;
  while (remaining > 0.5 && guard < 500) {
    const seg = Math.min(remaining, nW - srcX);
    ctx.drawImage(
      img,
      srcX, region.y, seg, region.height,
      destX, 0, seg * scaleX, destH
    );
    destX += seg * scaleX;
    remaining -= seg;
    srcX = 0; // subsequent segments start at the left edge of the next copy
    guard++;
  }
}

function cropImage(canvas, cropWidthCm, cropHeightCm, container, index, cropArea = null) {
  const context = canvas.getContext("2d");
  const errorDisplay = container.querySelector(`#error-message-${index}`);

  // Get the input elements for the specific index
  const inputContainer = container.querySelector(`[data-dimensions-input][data-index="${index}"]`);
  if (!inputContainer) {
    console.error(`Input container not found for index ${index}`);
    return;
  }
  const widthInput = inputContainer.querySelector('.crop-width');
  const heightInput = inputContainer.querySelector('.crop-height');

  const minWidth = parseFloat(widthInput.min);
  const maxWidth = parseFloat(widthInput.max);
  const minHeight = parseFloat(heightInput.min);
  const maxHeight = parseFloat(heightInput.max);

  const sourceImage = container.querySelector(".source-image");
  const addToCartBtn = document.querySelectorAll('.config-main-product button[name="add"]');

  // Limit to one digit after decimal while typing
  if (String(cropWidthCm).includes('.') || String(cropHeightCm).includes('.')) {
    const widthParts = String(cropWidthCm).split('.');
    const heightParts = String(cropHeightCm).split('.');
    if (widthParts[1] && widthParts[1].length > 1) {
      cropWidthCm = parseFloat(widthParts[0] + '.' + widthParts[1].slice(0, 1));
    }
    if (heightParts[1] && heightParts[1].length > 1) {
      cropHeightCm = parseFloat(heightParts[0] + '.' + heightParts[1].slice(0, 1));
    }
  }

  const isValid = !isNaN(cropWidthCm) && !isNaN(cropHeightCm) &&
    cropWidthCm >= minWidth && cropWidthCm <= maxWidth &&
    cropHeightCm >= minHeight && cropHeightCm <= maxHeight;

  if (isValid) {
    if (errorDisplay) {
      errorDisplay.textContent = "";
      errorDisplay.classList.remove(`error-active`);
    }
    if (addToCartBtn.length) {
      addToCartBtn.forEach(btn => {
        btn.removeAttribute('disabled');
        if (btn.querySelector(`.product_add_cart_btn`)) btn.querySelector(`.product_add_cart_btn`).textContent = `In den Warenkorb`;
      });
    }

    // Update DataLayer
    handleDataLayer(index, 'update');

  } else {
    if (errorDisplay) {
      errorDisplay.textContent = `Bitte gib eine gültige Höhe (${minHeight}-${maxHeight} cm) und Breite (${minWidth}-${maxWidth} cm) ein.`;
      errorDisplay.classList.add(`error-active`);
    }
    if (addToCartBtn.length) {
      addToCartBtn.forEach(btn => {
        btn.setAttribute('disabled', 'disabled');
        if (btn.querySelector(`.product_add_cart_btn`)) btn.querySelector(`.product_add_cart_btn`).textContent = `Ungültige Höhe oder Breite`;
      });
    }
    return;
  }
  //disabled the ATC btn if atleat one input box error there
  if (container.querySelectorAll(`.error-active`).length) {
    if (addToCartBtn.length) {
      addToCartBtn.forEach(btn => {
        btn.setAttribute('disabled', 'disabled');
        if (btn.querySelector(`.product_add_cart_btn`)) btn.querySelector(`.product_add_cart_btn`).textContent = `Ungültige Höhe oder Breite`;
      });
    }
  }

  // Wait for the source image if it isn't decoded yet
  if (!sourceImage.complete || !sourceImage.naturalWidth) {
    sourceImage.onload = () => {
      cropImage(canvas, cropWidthCm, cropHeightCm, container, index);
    };
    return;
  }

  // Compute the whole tiled composition and draw THIS tile's slice.
  // Everything uses NATURAL pixels, so the region is sampled at full
  // resolution (no blur) and the canvas matches the region (no stretch).
  const comp = computeComposition(container);
  if (!comp || !comp.crops[index]) return;
  const region = comp.crops[index];

  const frontendWidthInput = document.querySelector('input[name="properties[_frontend_width]"]');
  const frontendHeightInput = document.querySelector('input[name="properties[_frontend_height]"]');
  if (frontendWidthInput) frontendWidthInput.value = sourceImage.naturalWidth;
  if (frontendHeightInput) frontendHeightInput.value = sourceImage.naturalHeight;

  // Size the canvas to the SOURCE region → 1:1 draw (sharp, no stretch).
  const rw = Math.max(1, Math.round(region.width));
  const rh = Math.max(1, Math.round(region.height));
  canvas.width = rw;
  canvas.height = rh;
  context.imageSmoothingEnabled = true;
  context.imageSmoothingQuality = "high";
  context.clearRect(0, 0, rw, rh);
  drawTiledRegion(context, sourceImage, region, rw, rh, comp.nW);

  // Store this tile's crop (used by syncHiddenProperties for the cart).
  savedCropData[index] = {
    x: region.x,
    y: region.y,
    width: region.width,
    height: region.height,
    manual: !!cropGroup
  };

  // Legacy single crop inputs (kept for backwards compat).
  const cropXInput = document.querySelector('input[name="properties[_crop_x]"]');
  if (cropXInput) {
    const cropYInput = document.querySelector('input[name="properties[_crop_y]"]');
    const cropWInput = document.querySelector('input[name="properties[_crop_width]"]');
    const cropHInput = document.querySelector('input[name="properties[_crop_height]"]');
    cropXInput.value = region.x;
    if (cropYInput) cropYInput.value = region.y;
    if (cropWInput) cropWInput.value = region.width;
    if (cropHInput) cropHInput.value = region.height;
  }

  updatePrintProperties(index);
  syncHiddenProperties();
}

function syncHiddenProperties() {
  const container = document.getElementById('dynamic-config-properties');
  if (!container) return;

  container.innerHTML = ''; // reset

  // How many copies of the image the strip is built from (the horizontal loop
  // count). The PHP side should merge this many copies of the source image
  // side by side BEFORE applying each piece's crop, because the crop x/width
  // below are in that merged (looped) coordinate space.
  const srcImg = document.querySelector('.source-image');
  const nW = srcImg?.naturalWidth || 0;
  let loopCount = 1;
  const anyContainer = document.querySelector('.desktop-layout-wrapper, .mobile-layout-wrapper');
  if (anyContainer) {
    const comp = computeComposition(anyContainer);
    if (comp && comp.repeats) loopCount = comp.repeats;
  }

  appState.forEach((config, index) => {
    const crop = savedCropData[index] ?? {
      x: '',
      y: '',
      width: '',
      height: ''
    };

    const fields = {
      [`_crop_x_${index}`]: crop.x ?? '',
      [`_crop_y_${index}`]: crop.y ?? '',
      [`_crop_width_${index}`]: crop.width ?? '',
      [`_crop_height_${index}`]: crop.height ?? '',
      [`_print_width_cm_${index}`]: config.width ?? '',
      [`_print_height_cm_${index}`]: config.height ?? '',
      [`_frontend_width_${index}`]: nW || '',
      [`_frontend_height_${index}`]: srcImg?.naturalHeight ?? ''
    };

    Object.entries(fields).forEach(([key, value]) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = `properties[${key}]`;
      input.value = value;
      container.appendChild(input);
    });
  });

  // Global loop count for the whole composition (merge this many copies).
  const loopInput = document.createElement('input');
  loopInput.type = 'hidden';
  loopInput.name = 'properties[_number_of_loop_image]';
  loopInput.value = loopCount;
  container.appendChild(loopInput);
}

function handleInputChange(value, dimension, index, container) {
  // Update the global state with the new value
  appState[index][dimension] = value;
  saveState();

  // Belt-and-suspenders: a size change invalidates this panel's manual crop.
  if (savedCropData[index]) savedCropData[index].manual = false;

  const canvas = container.querySelector(
    `.cropped-image-wrap[data-canvas-index="${index}"] canvas`
  );

  if (canvas) {
    cropImage(
      canvas,
      appState[index].width,
      appState[index].height,
      container,
      index
    );
  }
  updatePrintProperties(index);
  calculatePrices();
  syncInputsFromState(container);

  // If the multi-crop modal is open, resize its boxes to the new dimensions.
  if (activeCropContext && imageAreapopup && !imageAreapopup.classList.contains('hidden')) {
    buildCropBoxes();
  }
  syncHiddenProperties();
  saveCropState();
}


// Update DataLayer
function handleDataLayer(configIndex, action = 'update') {
  window.dataLayer = window.dataLayer || [];

  // Find the existing size_inputed event
  let sizeEntry = dataLayer.find(entry => entry.event === 'size_inputed');

  // Create new if it doesn't exist and we're updating
  if (!sizeEntry) {
    if (action === 'update') {
      sizeEntry = {
        event: 'size_inputed',
        size: {}
      };
      dataLayer.push(sizeEntry);
    } else {
      return; // no size_inputed event to remove from
    }
  }

  // Define key for this config
  const key = `${configIndex + 1}_config_input`;

  if (action === 'update') {
    const height = Number(appState[configIndex]?.height || '');
    const width = Number(appState[configIndex]?.width || '');
    sizeEntry.size[key] = { height, width };

  } else if (action === 'remove') {
    if (sizeEntry.size[key]) {
      delete sizeEntry.size[key];

      // Optional: remove the whole size_inputed event if it's empty
      if (Object.keys(sizeEntry.size).length === 0) {
        const idx = dataLayer.indexOf(sizeEntry);
        if (idx > -1) dataLayer.splice(idx, 1);
      }
    }
  }
}


function handleScrollEvent(event) {
  activeStep();
}

function activeStep() {
  let stepCountElement = document.querySelectorAll('.config-main-product .desktop-layout-wrapper [data-config-step]');
  let stepImgElement = document.querySelectorAll('.config-main-product .product__media-wrapper [acive-step]');
  if (!stepCountElement.length && !stepImgElement.length) return;
  stepCountElement.forEach((step, index) => {
    let stepIndex = step.dataset.configStep;
    if (isInViewport(document.querySelector(`[data-config-step="${stepIndex}"]`))) {
      document.querySelectorAll(`.config-main-product [data-config-step]`).forEach(el => el.classList.remove('active'));
      document.querySelectorAll(`.config-main-product .product__media-wrapper [acive-step]`).forEach(el => el.classList.remove('active-step'));
      step.classList.add('active');
      stepImgElement[index].classList.add('active-step');
    }
  });
}

function isInViewport(el) {
  const rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}


function calculatePrices() {
  const additionalProdCheckbox = document.querySelectorAll(".config-main-product [data-additional-product-id]");
  const selectedVariantNameEle = document.querySelectorAll(".config-main-product [data-selected-option-title]");
  const finalPriceEle = document.querySelectorAll(".config-main-product [data-final-price], .config-main-product [data-config-sticky-bar-price]");
  const salePriceEle = document.querySelectorAll(".config-main-product [data-final-sale-price], .config-main-product [data-config-sticky-bar-sale-price]");
  const previewBoxAdditionalEle = document.querySelectorAll(".config-main-product [data-selected-addon-product]");
  const finalPreviewPrice = document.querySelectorAll(".config-main-product [data-final-price]");
  const salePreviewPrice = document.querySelectorAll(".config-main-product [data-final-sale-price]");
  const itemConfiguration = {};

  let totalProductPrice = 0;
  let totaloriginalPrice = 0;
  const variantName = selectedVariantNameEle[0]?.dataset.selectedOptionTitle;
  const colorCodeValue = document.querySelector(`.config-main-product [data-product-color-code]`)?.getAttribute('data-product-color-code');
  const variantNameLowerCase = (variantName || '').toLowerCase();

  if (appState.length === 0) {
    if (finalPriceEle.length) {
      finalPriceEle.forEach(element => element.innerHTML = priceFormat.format(0));
    }
    if (salePriceEle.length) {
      salePriceEle.forEach(element => element.innerHTML = priceFormat.format(0));
    }
    return;
  }

  // Clear all SKU's and  Price from data attribute
  if (selectedVariantNameEle.length) {
    selectedVariantNameEle.forEach(element => {
      [...element.attributes].forEach(attr => {
        if (attr.name.startsWith("data-final-sku") || attr.name.startsWith("data-item-price") || attr.name.startsWith("data-item-opt-price")) {
          element.removeAttribute(attr.name);
        }
      });
    });
  }

  appState.forEach((config, index) => {
    let BUILD_SKU;
    const calcHeightOg = config.height;
    const calcWidthOg = config.width;
    const heightForPrice = Math.round(Number(calcHeightOg));
    const widthForPrice = Math.round(Number(calcWidthOg));

    const calcHeight = Number(calcHeightOg) / 100;
    const calcWidth = Number(calcWidthOg) / 100;
    const matchedPrice = getMatchedPriceValue(heightForPrice, widthForPrice, variantName);
    const area = calcHeight * calcWidth;
    let BASE, AREA_FACTOR, EXPONENT;
    let productElement = document.querySelector('[data-klassik-area]');
    let klassikArea = parseFloat(productElement.dataset.klassikArea);
    let deluxeArea = parseFloat(productElement.dataset.deluxeArea);
    let ecoArea = parseFloat(productElement.dataset.ecoArea);

    // Preisparameter aus dem Theme-Editor (Abschnitt "Product Price Formula").
    // Fallbacks entsprechen der am 19.08.2026 gegen die Amazon-Preise gefitteten Fassung.
    const zahlOderStandard = (wert, standard) => {
      const n = parseFloat(wert);
      return Number.isFinite(n) ? n : standard;
    };
    const klassikBase   = zahlOderStandard(productElement.dataset.klassikBase, 10);
    const klassikExp    = zahlOderStandard(productElement.dataset.klassikExp, 0.911);
    const klassikHCoeff = zahlOderStandard(productElement.dataset.klassikHcoeff, 18.38);
    const klassikWCoeff = zahlOderStandard(productElement.dataset.klassikWcoeff, -5);
    // Materialstufe: ueber dieser Hoehe wird ein zweiter Nutzen angeschnitten (echter
    // Mehrpreis beim Lieferanten 2,92 EUR/m Breite, hier gedaempft weitergegeben).
    const hoehenStufeCm = zahlOderStandard(productElement.dataset.heightStepCm, 60);
    const stufenZuschlag = zahlOderStandard(productElement.dataset.heightStepSurcharge, 1.31);

    // HCOEFF/WCOEFF ersetzen die frueher fest verdrahteten -5*h und -10*w.
    let HCOEFF = -5, WCOEFF = -10, STUFE_AUFSCHLAG = 0;

    if (isKlassikMattVariant(variantNameLowerCase)) {
      BASE = klassikBase;
      AREA_FACTOR = klassikArea;
      EXPONENT = klassikExp;
      DISCOUNT = 0.8;
      HCOEFF = klassikHCoeff;
      WCOEFF = klassikWCoeff;
      if (calcHeightOg > hoehenStufeCm) {
        STUFE_AUFSCHLAG = stufenZuschlag * calcWidth;
      }
    } else if (isDeluxeGlasoptikVariant(variantNameLowerCase)) {
      BASE = 10;
      AREA_FACTOR = deluxeArea;
      EXPONENT = 0.75;
      DISCOUNT = 0.7;
    } else if (variantNameLowerCase.includes('eco matt') || variantNameLowerCase.includes('ecomatt')) {
      BASE = 5;
      AREA_FACTOR = ecoArea;
      EXPONENT = 0.8;
      DISCOUNT = 0.8;
    }

    const variant_sku = selectedVariantNameEle[0]?.dataset.selectedOptionSku;
    const skuInput = document.querySelector('input[name="properties[_original_sku]"]');
    if (variant_sku && skuInput) {
      skuInput.value = variant_sku;
    }

    if (matchedPrice) {
      const pricePerSqMeter = matchedPrice;
      let price_raw = BASE + AREA_FACTOR * Math.pow(area, EXPONENT) + HCOEFF * calcHeight + WCOEFF * calcWidth + STUFE_AUFSCHLAG;

      let productPrice = 0;
      let originalPrice = 0;

      if (salePriceEle.length) {
        originalPrice = Math.round(price_raw) + 0.90;
        productPrice = +(originalPrice * DISCOUNT).toFixed(2); // final price after discount
        totalProductPrice += productPrice;
        totaloriginalPrice += originalPrice;
      } else {
        productPrice = Math.round(price_raw) + 0.90;
        totalProductPrice += productPrice;
      }

      //save individual item price relative to its input value
      if (selectedVariantNameEle.length) {
        selectedVariantNameEle.forEach(element => {
          element.setAttribute(`data-item-opt-price-${index + 1}`, (pricePerSqMeter * 100).toFixed(2));
          element.setAttribute(`data-item-price-${index + 1}`, (productPrice * 100).toFixed(2));
        });
      }

      //save individual item sku relative to its input value
      if (isKlassikMattVariant(variantNameLowerCase)) {
        BUILD_SKU = `KRW1_${colorCodeValue || ''}_${calcHeightOg}_${calcWidthOg}`;
      } else if (isDeluxeGlasoptikVariant(variantNameLowerCase)) {
        BUILD_SKU = `KRW3_${colorCodeValue || ''}_${calcHeightOg}_${calcWidthOg}`;
      }
      if (selectedVariantNameEle.length) {
        selectedVariantNameEle.forEach(element => element.setAttribute(`data-final-sku-${index + 1}`, BUILD_SKU));
      }

      let key = `item-${index + 1}`;

      // initialize inner object if not exists
      if (!itemConfiguration[key]) {
        itemConfiguration[key] = {};
      }

      itemConfiguration[key][`item-inputs`] = `${calcHeightOg}cm x ${calcWidthOg}cm`;
      itemConfiguration[key][`item-option-price`] = (pricePerSqMeter * 100).toFixed(2);
      itemConfiguration[key][`item-price`] = (productPrice * 100).toFixed(2);
      itemConfiguration[key][`item-sku`] = BUILD_SKU;
    }
  });

  //save item configuration
  if (selectedVariantNameEle.length) {
    selectedVariantNameEle.forEach(element => element.setAttribute(`data-item-config`, JSON.stringify(itemConfiguration)));
  }

  const additionalPriceEl = document.querySelector(".config-main-product [data-additional-product-container] .prices");
  const selectedAdditionalProdOgPrice = additionalPriceEl ? Number(additionalPriceEl.dataset.additionalProdOgPrice) : 0;

  if (additionalProdCheckbox.length) {
    additionalProdCheckbox.forEach(checkbox => {
      checkbox.checked = false;
      if (!checkbox.checked && previewBoxAdditionalEle.length) {
        previewBoxAdditionalEle.forEach(ele => {
          if (ele.closest('li')) ele.closest('li').classList.add('hidden');
        });
      }
    });
  }

  if (salePriceEle.length) {
    let finalPriceWithAddon = totalProductPrice;
    let salePriceWithAddon = totaloriginalPrice;
    if (document.querySelectorAll('.config-main-product [data-additional-product-id]:not(:disabled):checked').length) {
      const additionalPrice = Number(selectedAdditionalProdOgPrice) / 100;
      finalPriceWithAddon += additionalPrice;
      salePriceWithAddon += additionalPrice;
    }

    if (finalPreviewPrice.length) {
      finalPreviewPrice.forEach(element => {
        element.setAttribute('data-final-price', (finalPriceWithAddon * 100).toFixed(2));
      });
    }
    if (salePreviewPrice.length) {
      salePreviewPrice.forEach(element => {
        element.setAttribute('data-final-sale-price', (salePriceWithAddon * 100).toFixed(2));
      });
    }

    if (finalPriceEle.length) {
      finalPriceEle.forEach(element => {
        element.innerHTML = priceFormat.format(finalPriceWithAddon);
      });
    }
    if (salePriceEle.length) {
      salePriceEle.forEach(element => {
        element.innerHTML = priceFormat.format(salePriceWithAddon);
      });
    }
  } else {
    let finalPriceWithAddon = totalProductPrice;
    if (document.querySelectorAll('.config-main-product [data-additional-product-id]:not(:disabled):checked').length) {
      const additionalPrice = Number(selectedAdditionalProdOgPrice) / 100;
      finalPriceWithAddon += additionalPrice;
    }

    if (finalPreviewPrice.length) {
      finalPreviewPrice.forEach(element => {
        element.setAttribute('data-final-price', (finalPriceWithAddon * 100).toFixed(2));
      });
    }

    if (finalPriceEle.length) {
      finalPriceEle.forEach(element => {
        element.innerHTML = priceFormat.format(finalPriceWithAddon);
      });
    }
  }
  savingComparedToOtherMaterial(variantName);
}

function handleAdditionalProdRadio() {
  let additionalProdCheckbox = document.querySelectorAll(".config-main-product [data-additional-product-id]:not(:disabled)");
  let finalPreviewPrice = document.querySelectorAll(".config-main-product [data-final-price], .config-main-product [data-final-sale-price]");
  let finalPriceEle = document.querySelectorAll(".config-main-product [data-final-price], .config-main-product [data-config-sticky-bar-price]");
  let finalSalePriceEle = document.querySelectorAll(".config-main-product [data-final-sale-price], .config-main-product [data-config-sticky-bar-sale-price]");
  let previewBoxAdditionalEle = document.querySelectorAll(".config-main-product [data-selected-addon-product]");
  if (additionalProdCheckbox.length) {
    additionalProdCheckbox.forEach(checkbox => {
      checkbox.addEventListener('change', function (event) {
        let getFinalPreviewPrice = (Number(document.querySelector(".config-main-product [data-final-price]").getAttribute('data-final-price'))) / 100;
        let getFinalPreviewSalePrice = (Number(document.querySelector(".config-main-product [data-final-sale-price]").getAttribute('data-final-sale-price'))) / 100;
        let getAdditionalPrice = (Number(document.querySelector(".config-main-product [data-final-price]").getAttribute('data-additional-prod-price'))) / 100;
        let currentCheckedPrice = Number(this.closest('.item-container').querySelector('[data-additional-prod-og-price]').getAttribute('data-additional-prod-og-price'));

        const isChecked = this.checked;
        let finalPrice = 0;
        let final_compare_price = 0;
        if (isChecked) {
          if (finalPreviewPrice.length) {
            finalPreviewPrice.forEach(element => element.setAttribute('data-additional-prod-price', currentCheckedPrice));
            if (finalPriceEle.length) {
              finalPriceEle.forEach(element => element.innerHTML = priceFormat.format(getFinalPreviewPrice + (currentCheckedPrice / 100)));
              finalPrice = getFinalPreviewPrice + (currentCheckedPrice / 100);
            }
            if (finalSalePriceEle.length) {
              finalSalePriceEle.forEach(element => element.innerHTML = priceFormat.format(getFinalPreviewSalePrice + (currentCheckedPrice / 100)));
              final_compare_price = getFinalPreviewSalePrice + (currentCheckedPrice / 100);
            }
          }
        } else {
          if (finalPreviewPrice.length) {
            finalPreviewPrice.forEach(element => element.setAttribute('data-additional-prod-price', 0));
            if (finalPriceEle.length) {
              finalPriceEle.forEach(element => element.innerHTML = priceFormat.format(getFinalPreviewPrice));
              finalPrice = getFinalPreviewPrice;
            }
            if (finalSalePriceEle.length) {
              finalSalePriceEle.forEach(element => element.innerHTML = priceFormat.format(getFinalPreviewSalePrice));
              final_compare_price = getFinalPreviewSalePrice;
            }
          }
        }

        if (this.checked) {
          if (previewBoxAdditionalEle.length) {
            previewBoxAdditionalEle.forEach(ele => {
              if (ele.closest('li')) {
                ele.closest('li').classList.remove('hidden');
              }
            });
          }
          additionalProdCheckbox.forEach(checkbox => checkbox.checked = true);
        } else {
          if (previewBoxAdditionalEle.length) {
            previewBoxAdditionalEle.forEach(ele => {
              if (ele.closest('li')) {
                ele.closest('li').classList.add('hidden');
              }
            });
          }
          additionalProdCheckbox.forEach(checkbox => checkbox.checked = false);
        }
        const priceEle = document.querySelector(
          '.config-main-product .final-total-price[data-selected-option-title][data-final-price]'
        );
        const compare_price = document.querySelector(
          '.config-main-product .final-total-sale-price[data-selected-option-title][data-final-sale-price]'
        );
        let total_saving_prices = document.querySelectorAll('.total_saving_price');
        total_saving_prices.forEach((total_saving_price) => {
          if (total_saving_price && final_compare_price && finalPrice) {
            total_saving_price.innerHTML = `Du sparst ${priceFormat.format((final_compare_price - finalPrice))}`;
          }
        })
      });
    });
  }
}

function savingComparedToOtherMaterial(variantName) {
  let variantNameLowerCase = variantName.toLowerCase();
  let savingTextEle = document.querySelectorAll(".config-main-product [data-price-saved-text]");
  const priceEle = document.querySelector(
    '.config-main-product .final-total-price[data-selected-option-title][data-final-price]'
  );
  const compare_price = document.querySelector(
    '.config-main-product .final-total-sale-price[data-selected-option-title][data-final-sale-price]'
  );
  let finalPrice;
  let final_compare_price;

  if (priceEle) {
    finalPrice = (+priceEle.dataset.finalPrice) / 100;
  }
  if (compare_price) {
    final_compare_price = (+compare_price.dataset.finalSalePrice) / 100;
  }

  let selectedVariantPrice = 0, perSqMeterPrice;

  if (savingTextEle.length) {

    //get total input box price
    priceEle.getAttributeNames().forEach(attr => {
      if (attr.startsWith("data-item-opt-price")) {
        selectedVariantPrice += Number(priceEle.getAttribute(attr));
      }
    });

    selectedVariantPrice = selectedVariantPrice / 100;

    if (isKlassikMattVariant(variantNameLowerCase)) {
      perSqMeterPrice = 140 * appState.length;
    } else if (isDeluxeGlasoptikVariant(variantNameLowerCase)) {
      perSqMeterPrice = 350 * appState.length;
    }

    let priceSaving = (finalPrice / selectedVariantPrice) * (perSqMeterPrice - selectedVariantPrice);
    let priceSavingFormat = priceFormat.format(priceSaving);

    savingTextEle.forEach(element => {
      if (isKlassikMattVariant(variantNameLowerCase)) {
        element.innerHTML = `Du sparst ca. ${priceSavingFormat} gegenüber Aluverbund-Platten.`;
      } else if (isDeluxeGlasoptikVariant(variantNameLowerCase)) {
        element.innerHTML = `Du sparst ca. ${priceSavingFormat} gegenüber einer Glas-Rückwand.`;
      }
    });
  }
  // data-option-title in the markup is only ever authored in German
  // ("Klassik Matt" / "Deluxe Glasoptik"); map the (possibly translated)
  // variantName back onto that canonical label before matching against it.
  const tooltipMatchTitle = isKlassikMattVariant(variantNameLowerCase)
    ? 'Klassik Matt'
    : isDeluxeGlasoptikVariant(variantNameLowerCase)
      ? 'Deluxe Glasoptik'
      : variantName;
  let tooltipEle = document.querySelectorAll(".config-main-product .price-saved-info [data-option-title]");
  let tooltipCurrentEle = document.querySelectorAll(`.config-main-product .price-saved-info [data-option-title="${tooltipMatchTitle}"]`);
  if (tooltipEle.length) tooltipEle.forEach(el => el.classList.add('hidden'));
  if (tooltipCurrentEle.length) tooltipCurrentEle.forEach(el => el.classList.remove('hidden'));
  let total_saving_prices = document.querySelectorAll('.total_saving_price');
  total_saving_prices.forEach((total_saving_price) => {
    if (total_saving_price && final_compare_price && finalPrice) {
      total_saving_price.innerHTML = `Du sparst ${priceFormat.format((final_compare_price - finalPrice))}`;
    }
  })
}

// Finish/variant name aliases per storefront language — the variant's
// displayed title/option value is translated per locale (de/fr/it/es), so a
// bare German-only string match breaks on non-German storefronts. Keep this
// list in sync with isKlassikMattVariant()/isDeluxeGlasoptikVariant() in custom.js.
// var, not const: this script can be re-executed (e.g. after an AJAX section
// re-render rebinds handlers to fresh DOM), and a top-level const/let throws
// "already declared" on a second run, aborting everything after it.
var KLASSIK_MATT_ALIASES = ['klassik matt', 'opaco', 'mate', 'mat'];
var DELUXE_GLASOPTIK_ALIASES = ['deluxe glasoptik', 'effetto vetro', 'óptica de vidrio', 'aspect verre'];

function isKlassikMattVariant(name) {
  if (!name) return false;
  const lower = name.toLowerCase();
  return KLASSIK_MATT_ALIASES.some(alias => lower.includes(alias));
}

function isDeluxeGlasoptikVariant(name) {
  if (!name) return false;
  const lower = name.toLowerCase();
  return DELUXE_GLASOPTIK_ALIASES.some(alias => lower.includes(alias));
}

function getMatchedPriceValue(height, width, selectedOption) {
  function isInRange(value, rangeStr) {
    const [min, max] = rangeStr.split('-').map(Number);
    return value >= min && value <= max;
  }

  let heightEntry;
  if (isKlassikMattVariant(selectedOption)) {
    heightEntry = klassikMattPriceGroup.find(item => isInRange(height, item.height));
  } else if (isDeluxeGlasoptikVariant(selectedOption)) {
    heightEntry = deluxGlassopticPriceGroup.find(item => isInRange(height, item.height));
  }

  if (heightEntry) {
    const widthEntry = heightEntry.widths.find(item => isInRange(width, item.width));
    if (widthEntry) {
      return widthEntry.value;
    }
  }

  return null;
}

/* ==========================================================================
   MAX TOTAL MOTIVE LENGTH
   --------------------------------------------------------------------------
   The motive may only be printed up to a certain total length (default 5 m),
   because not every motive can be repeated endlessly. The limit is the SUM of
   all pieces' widths in cm. Override per product by putting
   data-max-total-width="500" on the element that also carries [data-klassik-area]
   (or any element in the page).
   ========================================================================== */
function getMaxTotalWidthCm(container) {
  const el = (container || document).querySelector('[data-max-total-width]') ||
    document.querySelector('[data-max-total-width]');
  const v = el ? parseFloat(el.dataset.maxTotalWidth) : NaN;
  return Number.isFinite(v) && v > 0 ? v : 500; // 5 m default
}

function getTotalWidthCm() {
  return appState.reduce((a, c) => a + (Number(c.width) || 0), 0);
}

// Sum of every OTHER piece's width (excludes the given index).
function getOtherWidthsSum(index) {
  return appState.reduce((a, c, i) => a + (i === index ? 0 : (Number(c.width) || 0)), 0);
}

// Clamp a width input so the SUM of all pieces never exceeds the max motive
// length (5 m). If the typed value would overflow, replace it with exactly the
// remaining allowance (e.g. others = 450 of 500 → this field is capped at 50).
function clampWidthToTotal(input, index, container) {
  const maxTotal = getMaxTotalWidthCm(container);
  const remaining = Math.max(0, maxTotal - getOtherWidthsSum(index));
  const v = parseFloat(input.value);
  if (!isNaN(v) && v > remaining) {
    input.value = String(remaining);
    return { clamped: true, remaining, maxTotal };
  }
  return { clamped: false, remaining, maxTotal };
}

// Show the "limit reached" message on the specific input's error row.
function showInputWidthError(container, index, maxTotal, remaining) {
  const el = container.querySelector(`#error-message-${index}`);
  if (!el) return;
  const meters = (maxTotal / 100).toLocaleString('de-DE');
  el.textContent = `Maximale Gesamtbreite ${maxTotal} cm (${meters} m) erreicht – auf ${remaining} cm begrenzt.`;
  el.classList.add('error-active');
}

function getTotalWidthErrorEl(container) {
  const wrap = container.querySelector('.config-dimensions-input-wrapper');
  if (!wrap) return null;
  let el = wrap.querySelector('.config-total-width-error');
  if (!el) {
    el = document.createElement('div');
    el.className = 'config-total-width-error error-message';
    wrap.appendChild(el);
  }
  return el;
}

// Disable Add-to-Cart + show a message when the combined width exceeds the max.
// Runs AFTER the per-piece render so it has the final say on the ATC button.
function validateTotalWidth(container) {
  const maxTotal = getMaxTotalWidthCm(container);
  const total = getTotalWidthCm();
  const over = total > maxTotal;
  const meters = (maxTotal / 100).toLocaleString('de-DE');

  const errEl = getTotalWidthErrorEl(container);
  if (errEl) {
    if (over) {
      errEl.textContent = `Die Gesamtbreite aller Teile darf höchstens ${maxTotal} cm (${meters} m) betragen. Aktuell: ${total} cm.`;
      errEl.classList.add('error-active');
      errEl.style.display = '';
    } else {
      errEl.textContent = '';
      errEl.classList.remove('error-active');
    }
  }

  if (over) {
    document.querySelectorAll('.config-main-product button[name="add"]').forEach((btn) => {
      btn.setAttribute('disabled', 'disabled');
      const t = btn.querySelector('.product_add_cart_btn');
      if (t) t.textContent = `Maximale Gesamtbreite ${maxTotal} cm`;
    });
  }
  return !over;
}

function updateAddButtonVisibility(container) {
  const currentElements = container.querySelectorAll('[data-dimensions-input]');
  if (currentElements.length >= 5) {
    currentElements.forEach(element => {
      const addBtn = element.closest(`.config-dimensions-input-wrapper`)?.querySelector(`#addMoreConfigPro`);
      if (addBtn) addBtn.classList.add(`hidden`);
    });
  } else {
    currentElements.forEach(element => {
      const addBtn = element.closest(`.config-dimensions-input-wrapper`)?.querySelector(`#addMoreConfigPro`);
      if (addBtn) addBtn.classList.remove(`hidden`);
    });
  }
}


/* ==========================================================================
   MULTI-CROP OVERLAY
   --------------------------------------------------------------------------
   Replaces Cropper.js. Draws one draggable box PER config over the source
   image inside #resizeModalWindow. Each box is sized proportionally:
     boxWidth  = (config.width  / maxWidth)  * imageNaturalWidth
     boxHeight = (config.height / maxHeight) * imageNaturalHeight
   On apply, each box's position+size (in natural image pixels) is saved to
   savedCropData[i] with manual:true, so cropImage() redraws each panel from
   exactly that region.
   ========================================================================== */

// Show the height/width inputs inside the resize modal ONLY for a single
// config. With 2+ configs the modal is just for positioning the crop boxes,
// so the dimension inputs are hidden there.
function toggleModalConfigInputs() {
  if (!imageAreapopup) return;
  const hide = appState.length > 1;
  imageAreapopup.querySelectorAll('.config-dimensions-input-wrapper').forEach((w) => {
    w.style.display = hide ? 'none' : '';
  });
}

function getMaxDims(container) {
  const maxW = parseFloat(container.querySelector('[data-max-width]')?.dataset.maxWidth);
  const maxH = parseFloat(container.querySelector('[data-max-height]')?.dataset.maxHeight);
  return {
    maxWidth: isNaN(maxW) ? 100 : maxW,
    maxHeight: isNaN(maxH) ? 100 : maxH
  };
}

function openMultiCropModal(container) {
  if (!imageAreapopup || !imageAreaPopupImage) return;

  const productSourceImg = container.querySelector(".source-image");
  if (!productSourceImg) return;

  const { maxWidth, maxHeight } = getMaxDims(container);

  activeCropContext = {
    container,
    maxWidth,
    maxHeight,
    overlay: null,
    boxes: {}, // index -> { el, label, region }
    groupBackup: cropGroup ? { x: cropGroup.x, y: cropGroup.y } : null
  };

  // (re)load the image into the modal, then build boxes once it's decoded
  imageAreaPopupImage.onload = function () {
    imageAreapopup.classList.remove('hidden');
    toggleModalConfigInputs();
    syncPopupWithMain(getActiveIndex());
    buildCropBoxes();
    window.addEventListener('resize', buildCropBoxes);
  };

  // set src last; if it's cached, onload may fire synchronously
  imageAreaPopupImage.src = productSourceImg.src;
  imageAreapopup.classList.remove('hidden');
  toggleModalConfigInputs();
  syncPopupWithMain(getActiveIndex());

  // if already complete (cached), build immediately
  if (imageAreaPopupImage.complete && imageAreaPopupImage.naturalWidth) {
    buildCropBoxes();
    window.addEventListener('resize', buildCropBoxes);
  }
}

function buildCropBoxes() {
  if (!activeCropContext) return;

  const img = imageAreaPopupImage;
  if (!img.naturalWidth) return;

  const comp = computeComposition(activeCropContext.container);
  if (!comp) return;

  // read the image's laid-out box (visibility:hidden keeps layout, so these
  // stay valid across rebuilds)
  const w = img.clientWidth;
  const h = img.clientHeight;
  if (!w || !h) return;

  const parent = img.parentElement;
  if (!parent) return;
  if (getComputedStyle(parent).position === 'static') {
    parent.style.position = 'relative';
  }

  // Fit the whole looped strip into the available width. When there's no loop
  // (tiledW == nW) this equals the image's normal size.
  const availableW = parent.clientWidth || w;
  const scale = Math.min(w / comp.nW, availableW / comp.tiledW);
  const stripW = comp.tiledW * scale;
  const stripH = comp.nH * scale;
  const left = Math.max(0, (availableW - stripW) / 2);
  const top = img.offsetTop + Math.max(0, (h - stripH) / 2);

  // Hide the single <img>; we paint the (repeated) image onto a canvas.
  img.style.visibility = 'hidden';

  // Repeated-image STAGE drawn on a real <canvas> so it renders reliably no
  // matter what the modal's CSS does (background layers were not showing).
  let stage = activeCropContext.stage;
  if (!stage) {
    stage = document.createElement('canvas');
    stage.className = 'multi-crop-stage';
    stage.style.position = 'absolute';
    stage.style.zIndex = '4';
    stage.style.pointerEvents = 'none';
    parent.appendChild(stage);
    activeCropContext.stage = stage;
  }
  stage.style.left = left + 'px';
  stage.style.top = top + 'px';
  stage.style.width = stripW + 'px';
  stage.style.height = stripH + 'px';

  const dpr = window.devicePixelRatio || 1;
  stage.width = Math.max(1, Math.round(stripW * dpr));
  stage.height = Math.max(1, Math.round(stripH * dpr));

  const sctx = stage.getContext('2d');
  sctx.setTransform(1, 0, 0, 1, 0, 0);
  sctx.clearRect(0, 0, stage.width, stage.height);
  sctx.imageSmoothingEnabled = true;
  sctx.imageSmoothingQuality = 'high';

  // Draw the image once per required copy, side by side (the horizontal loop).
  const copyW = comp.nW * scale * dpr;
  const copyH = comp.nH * scale * dpr;
  for (let c = 0; c < comp.repeats; c++) {
    sctx.drawImage(img, 0, 0, comp.nW, comp.nH, c * copyW, 0, copyW, copyH);
  }

  // Spotlight: wash the whole strip dark, then redraw ONLY the selected tile
  // regions at full brightness so they stand out and everything else is dimmed.
  sctx.fillStyle = 'rgba(0,0,0,0.55)';
  sctx.fillRect(0, 0, stage.width, stage.height);

  appState.forEach((config, index) => {
    const region = comp.crops[index];
    if (!region) return;
    // redraw this tile bright (wrap onto the next copy if it crosses a seam)
    let remaining = region.width;
    let srcX = ((region.x % comp.nW) + comp.nW) % comp.nW;
    let destX = region.x * scale * dpr;
    const destY = region.y * scale * dpr;
    const destH = region.height * scale * dpr;
    let guard = 0;
    while (remaining > 0.5 && guard < 500) {
      const seg = Math.min(remaining, comp.nW - srcX);
      const segDW = seg * scale * dpr;
      sctx.drawImage(img, srcX, region.y, seg, region.height, destX, destY, segDW, destH);
      destX += segDW;
      remaining -= seg;
      srcX = 0;
      guard++;
    }
  });

  // Overlay that holds the draggable boxes, aligned to the strip.
  let overlay = activeCropContext.overlay;
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.className = 'multi-crop-overlay';
    overlay.style.position = 'absolute';
    overlay.style.zIndex = '5';
    overlay.style.touchAction = 'none';
    parent.appendChild(overlay);
    activeCropContext.overlay = overlay;
  }
  overlay.style.left = left + 'px';
  overlay.style.top = top + 'px';
  overlay.style.width = stripW + 'px';
  overlay.style.height = stripH + 'px';

  // Remove boxes for configs that no longer exist
  Object.keys(activeCropContext.boxes).forEach((k) => {
    if (!appState[k]) {
      activeCropContext.boxes[k].el.remove();
      delete activeCropContext.boxes[k];
    }
  });

  // One box per config, positioned/sized from the composition (adjacent row,
  // possibly spanning repeated image copies).
  appState.forEach((config, index) => {
    const region = comp.crops[index];
    if (!region) return;

    let entry = activeCropContext.boxes[index];
    if (!entry) {
      const el = document.createElement('div');
      el.className = 'multi-crop-box';
      el.style.position = 'absolute';
      el.style.boxSizing = 'border-box';
      el.style.border = '2px dashed #14b6ef';
      el.style.background = 'transparent';
      el.style.cursor = 'move';
      el.style.display = 'flex';
      el.style.alignItems = 'center';
      el.style.justifyContent = 'center';
      el.style.color = '#14b6ef';
      el.style.fontSize = '12px';
      el.style.fontWeight = '600';
      el.style.textShadow = '0 1px 2px rgba(0,0,0,0.6)';
      el.style.userSelect = 'none';

      const label = document.createElement('span');
      label.className = 'multi-crop-label';
      el.appendChild(label);

      overlay.appendChild(el);
      entry = { el, label };
      activeCropContext.boxes[index] = entry;
      makeBoxDraggable(index);
    }

    entry.region = region;
    entry.el.style.left = (region.x * scale) + 'px';
    entry.el.style.top = (region.y * scale) + 'px';
    entry.el.style.width = (region.width * scale) + 'px';
    entry.el.style.height = (region.height * scale) + 'px';
    if (entry.label) {
      entry.label.textContent = `${index + 1}  ·  ${config.height}×${config.width} cm`;
    }
  });

  activeCropContext.scale = scale;
  activeCropContext.comp = comp;

  // keep the modal's dimension inputs shown/hidden per current config count
  toggleModalConfigInputs();
}

function makeBoxDraggable(index) {
  const entry = activeCropContext.boxes[index];
  if (!entry) return;
  const el = entry.el;

  let startX = 0, startY = 0, g0 = null, dragging = false;

  const onDown = (e) => {
    e.preventDefault();
    dragging = true;
    const p = e.touches ? e.touches[0] : e;
    startX = p.clientX;
    startY = p.clientY;
    // remember where the whole row started (natural px)
    const comp = activeCropContext.comp;
    g0 = { x: comp.gx, y: comp.gy };

    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onUp);
    document.addEventListener('touchmove', onMove, { passive: false });
    document.addEventListener('touchend', onUp);
  };

  const onMove = (e) => {
    if (!dragging || !activeCropContext) return;
    if (e.cancelable) e.preventDefault();
    const p = e.touches ? e.touches[0] : e;

    const scale = activeCropContext.scale || 1;
    const dxNat = (p.clientX - startX) / scale;
    const dyNat = (p.clientY - startY) / scale;

    // Move the WHOLE row together by shifting the shared group offset.
    cropGroup = { x: g0.x + dxNat, y: g0.y + dyNat };
    buildCropBoxes(); // recomputes (and clamps) the row, repaints every box

    // keep cropGroup clamped to what was actually applied
    if (activeCropContext.comp) {
      cropGroup = { x: activeCropContext.comp.gx, y: activeCropContext.comp.gy };
    }
  };

  const onUp = () => {
    dragging = false;
    document.removeEventListener('mousemove', onMove);
    document.removeEventListener('mouseup', onUp);
    document.removeEventListener('touchmove', onMove);
    document.removeEventListener('touchend', onUp);
  };

  el.addEventListener('mousedown', onDown);
  el.addEventListener('touchstart', onDown, { passive: false });
}

function applyMultiCropModal() {
  if (!activeCropContext) {
    closeMultiCropModal(false);
    return;
  }
  // The composition already reflects the dragged cropGroup — just commit.
  closeMultiCropModal(true);
}

function closeMultiCropModal(save) {
  const ctx = activeCropContext;

  if (imageAreapopup) imageAreapopup.classList.add('hidden');
  window.removeEventListener('resize', buildCropBoxes);
  if (ctx && ctx.overlay) ctx.overlay.remove();
  if (ctx && ctx.strip) ctx.strip.remove();
  if (ctx && ctx.stage) ctx.stage.remove();
  if (imageAreaPopupImage) imageAreaPopupImage.style.visibility = '';
  activeCropContext = null;

  // On cancel, revert any drag done in this session.
  if (!save && ctx && ctx.groupBackup !== undefined) {
    cropGroup = ctx.groupBackup;
  }

  // Redraw every layout's previews from the final composition.
  document.querySelectorAll(".desktop-layout-wrapper, .mobile-layout-wrapper").forEach((container) => {
    if (!container.querySelector('.cropped-image-canvas')) return;
    syncInputsFromState(container);
  });
  syncHiddenProperties();
  saveCropState();
}


if (Shopify.designMode) {
  document.addEventListener('shopify:block:select', () => {
    const configContainers = document.querySelectorAll(".desktop-layout-wrapper, .mobile-layout-wrapper");
    initContainer(configContainers);
  });
  document.addEventListener('shopify:block:deselect', () => {
    const configContainers = document.querySelectorAll(".desktop-layout-wrapper, .mobile-layout-wrapper");
    initContainer(configContainers);
  });
  document.addEventListener('shopify:section:load', () => {
    const configContainers = document.querySelectorAll(".desktop-layout-wrapper, .mobile-layout-wrapper");
    initContainer(configContainers);
  });
  document.addEventListener('shopify:section:reorder', () => {
    const configContainers = document.querySelectorAll(".desktop-layout-wrapper, .mobile-layout-wrapper");
    initContainer(configContainers);
  });
}
